(function($, BaseAPI) {
	"use strict";

	function getCheckboxLabel(user) {
		if (user.email)
			return user.caption + ' &lt;' + user.email + '&gt;';
		return user.caption;
	}

	/** Utilisée pour trier les User et Profile selon leur Caption */
	function compareByCaption(l,r) {
		return l.caption.localeCompare(r.caption);
	}

	/**
	 * Ce plugin crée un popin permettant d'envoyer une notification de partage de page
	 * aux utilisateurs sélectionnés et de notifier aussi par email lorsque la case
	 * 'Envoyer mail' est cochée
	 */
	$.fn.materialPopinNotification = function(options) {

		var profileColor = "#717171";

		// Injection des options par défaut
		options = $.extend({}, $.fn.materialPopinNotification.defaultOptions, options);

		var lang = $.fn.materialPopinNotification.langs[options.lang];

		var template = $(''
			+ '<form class="form-horizontal">'
			+ '  <div class="form-group">'
			+ '    <label for="material-notification-message" class="col-md-2 control-label">' + lang['Message'] + '</label>'
			+ '    <div class="col-md-10"><input id="material-notification-message" type="text" class="form-control" value="" /></div>'
			+ '  </div>'
			+ '  <div class="form-group">'
			+ '    <label for="material-notification-profiles" class="col-md-2 control-label">' + lang['Profiles'] + '</label>'
			+ '    <div class="col-md-4"><select id="material-notification-profiles" class="form-control"></select></div>'
			+ '    <div class="col-md-2" style="padding-top: 5px;">'
			+ '      <input id="material-notification-email" type="checkbox"/><label for="material-notification-email">' + lang['EmailNotification'] + '</label>'
			+ '    </div>'
			+ '    <div class="col-md-3" style="padding-top: 5px;">'
			+ '      <input id="material-notification-email-bcc" type="checkbox"/><label for="material-notification-email-bcc">' + lang['EmailNotificationBcc'] + '</label>'
			+ '    </div>'
			+ '  </div>'
			+ '  <div class="form-group" id="material-notification-to-label">'
			+ '    <label class="col-md-2 control-label">' + lang['Notify'] + '</label>'
			+ '  </div>'
			+ '  <div class="form-group">'
			+ '    <ul id="material-notification-to">'
			+ '    </ul>'
			+ '  </div>'
			+ '</form>'
			+ '');

		template.css('display', 'flex').css('flex-direction', 'column').css('height', '100%');
		template.find('>.form-group').css('margin', '0');
		template.find('>div:first-child').css('flex', '0 0 auto').css('margin', '10px 0 10px 0');
		template.find('>div:last-child').css('flex', '1 1 auto').css('overflow-y','scroll');
		template.find('>.form-group>.control-label').css('padding-right', '15px');

		var profiles = template.find('#material-notification-profiles');
		var notifyTo = template.find('#material-notification-to');
		var message = template.find('#material-notification-message');
		var email = template.find('#material-notification-email');
		var emailBcc = template.find('#material-notification-email-bcc');

		var usersMapById = {};
		options.users.forEach(function(user) {
			usersMapById[user['id']] = user;
		});

		function getUserIdNotified() {
			return notifyTo.find('input:checked')
				.map(function () { return parseInt($( this ).attr("data-user-id"));})
				.toArray();
		}

		function doesOneOfNotifiedUsersHasAnEmail() {
			return getUserIdNotified().some(function(userId) {
				var user = usersMapById[userId];
				return user && user.email && user.email.length > 0;
			});
		}

		// Notification by email is disabled until at least one user with email is selected
		email.change(function(event) {
			return doesOneOfNotifiedUsersHasAnEmail();
		});

		email.materialCheckbox({});
		email.closest('.col-md-2').css("display", "none");
		
		emailBcc.materialCheckbox({});
		emailBcc.closest('.col-md-3').css("display", "none");
		emailBcc.prop('checked', options.sendMailAllowed === true);
		
		// Check box email is hidden when none of notified users get an email
		function checkNotifyByEmailValid() {
			if (options.sendMailAllowed) {
				var foundAnEmail = doesOneOfNotifiedUsersHasAnEmail();
				email.closest('.col-md-2').toggle(foundAnEmail);
				var isEmailChecked = email.prop('checked');
				if (isEmailChecked === true && foundAnEmail === false) {
					email.prop('checked', false);
				}
				emailBcc.closest('.col-md-3').toggle(foundAnEmail);
			}
		}

		// Selection d'un profil lang['SelectUsers']
		var profileMessage = '';
		profiles.append($('<option />')
				.attr('value', '')
				.prop('disabled', true)
				.css('color', "lightgray" )
				.prop('selected', true)
				.text(profileMessage));

		profiles.append(options.profiles
			.sort(compareByCaption)
			.map(function(profile, index) {
				return $('<option />')
					.attr('value', "" + profile.id)
					.text(profile.caption)[0];
		}));
		profiles.css('color', profileColor);

		profiles.change(function(event) {
			var profileId = profiles.find("option:selected").val();
			var userOfProfile = notifyTo.find('input[data-profile='+profileId+']');
			var userOfProfileCount = userOfProfile.length;
			var userOfProfileCheckedCount = notifyTo.find('input[data-profile='+profileId+'][type="checkbox"]:checked').length;
			var checkAll = userOfProfileCheckedCount < userOfProfileCount;
			// Check all user of the profile selected.
			userOfProfile.prop('checked', checkAll);
			checkNotifyByEmailValid();
			profiles.prop("selectedIndex", 0);
		});

		// Afficher les users
		notifyTo.css('list-style-type','none').css('margin','0').css('padding','0');
		notifyTo.append( options.users
			.sort(compareByCaption)
			.map(function(user, index) {
				var checkboxLabel = getCheckboxLabel(user);
				var divUser = $(''
					+ '    <li class="col-md-offset-2 col-md-10"'
					+ '      <div class="checkbox">'
					+ '        <label><input type="checkbox" data-user-id="'+user.id+'" data-profile="'+user.profileId+'"/>'+checkboxLabel+'</label>'
					+ '      </div>'
					+ '    </li>'
					+ '');
				return divUser;
		}));
		notifyTo.find("input").materialCheckbox({});


		notifyTo.change(function(event) {
			checkNotifyByEmailValid();
		});

		// Message
		message.val(options.message);

		// Affichage du popin une fois que tout est prêt
		$(this).css('height', '100%').append(template).materialPopin({
			title: lang['Title'],
			closeButtonTitle: lang['CancelButton'],
			buttons : [{
				icon : 'done',
				visible : true,
				title: lang['SendButton'],
				onclickPromise : function validate() {
					// Collecte les données du popin de notification
					var notification = new $.fn.materialPopinNotification.Notification();
					notification.message = message.val();
					notification.sendMail = email.prop('checked');
					notification.sendBccMail = emailBcc.prop('checked');
					notification.userIds = getUserIdNotified();
					notification.data = options.data;
					notification.origin = options.origin;

					// Vérification du formulaire
					var notificationErrorNoUserSelected = notification.userIds.length === 0;
					var notificationErrorMessageUndef = !notification.message;
					var notificationErrorMessageOutOfRange = notification.message.length > options.messageMaxLength;
					var notificationErrorDataOutOfRange = notification.data.length > options.dataMaxLength;
					// TODO Define what to do when notificationErrorDataOutOfRange occurs

					message.closest('.form-group').toggleClass('has-error', notificationErrorMessageUndef || notificationErrorMessageOutOfRange);
					notifyTo.closest('.form-group').toggleClass('has-error', notificationErrorNoUserSelected);
					template.find('#material-notification-to-label').css('color', notificationErrorNoUserSelected ?'red' : '');

					if (notificationErrorNoUserSelected || notificationErrorMessageUndef || notificationErrorMessageOutOfRange || notificationErrorDataOutOfRange)
						return $.Deferred().reject();

					// Envoi de la notification et fermeture auto (sauf en cas d'erreur)
					return options.execute(notification).fail(function(errorMessage) {
						options.error(errorMessage || lang["NotificationErrorUnexpected"]);
					});
				}
			}]
		});
	};

	/** La classe représentant la notification saisi par l'utilisateur quand il valide le popin */
	$.fn.materialPopinNotification.Notification = function() {
		this.userIds = [];
		this.message = '';
		this.data = '';
		this.sendMail = false;
		this.sendBccMail = false;
	};

	/** Traduction des libellés utilisés dans les différentes langues supportées */
	$.fn.materialPopinNotification.langs = {
		fr: {
			Title: 'Partager la page',
			SelectUsers: 'Cocher ou décocher des utilisateurs par profil',
			SendButton: 'Notifier',
			CancelButton: 'Annuler',
			CancelConfirmation: 'Toutes les modifications seront perdues. Êtes-vous sûr ?',
			Profiles: 'Profils',
			Notify: 'Notifier à',
			Message: 'Message',
			EmailNotification: 'Envoyer e-mail',
			EmailNotificationBcc: 'Envoi en copie cachée',
			errors: {
				NotificationErrorNoUserSelected: 'Aucun destinataire n\'est sélectionné.',
				NotificationErrorMessageUndef: 'Le message est manquant.',
				NotificationErrorMessageOutOfRange: 'Le message dépasse la taille maximun autorisée.',
				NotificationErrorUnexpected: 'Echec de la notification.',
			},
		},
		en: {
			Title: 'Share a link',
			SelectUsers: 'Check or uncheck users by profiles',
			SendButton: 'Notify',
			CancelButton: 'Cancel',
			CancelConfirmation: 'All modifications will be lost. Are you sure you want to close this window ?',
			Profiles: 'Profiles',
			Notify: 'Notify',
			Message: 'Message',
			EmailNotification: 'Send email',
			EmailNotificationBcc: 'Send BCC',
			errors: {
				NotificationErrorNoUserSelected: 'No recipient selected.',
				NotificationErrorMessageUndef: 'Message is missing.',
				NotificationErrorMessageOutOfRange: 'Message exceeds maximun size allowed.',
				NotificationErrorUnexpected: 'Failed to notify.',
			},
		},
		de: {
			Title: 'Seite teilen',
			SelectUsers: 'Aktivieren oder Deaktivieren von Benutzern nach Profil',
			SendButton: 'Absenden',
			CancelButton: 'Abbrechen',
			CancelConfirmation: 'Alle Änderungen gehen verloren. Sind Sie sicher?',
			Profiles: 'Profile',
			Notify: 'Benachrichtigen',
			Message: 'Nachricht',
			EmailNotification: 'email senden',
			EmailNotificationBcc: 'Blindkopie senden',
			errors: {
				NotificationErrorNoUserSelected: 'Kein Empfänger ausgewählt.',
				NotificationErrorMessageUndef: 'Die Nachricht fehlt.',
				NotificationErrorMessageOutOfRange: 'Die Nachricht überschreitet die maximal zulässige Größe.',
				NotificationErrorUnexpected: 'Ein unerwarteter Fehler ist aufgetreten. Der Versand ist nicht erfolgt.',
			},
		}
	};

	/** Options par défaut pour la construction du popin de notification */
	$.fn.materialPopinNotification.defaultOptions = {
		lang: 'fr',
		sendMail: false, // Warn the notification by mail the users which get an email
		sendMailAllowed: false, // Allow to warn notification by email
		sendBccMail: false,

		profiles: [],
		users:[],

		message: '',
		messageMaxLength: 128, // message size is defined in common_notifications table

		data: '',
		dataMaxLength: 255, // data Size is in common_notifications table

		// Exemple d'une fonction execute 
		execute: function(notification) {
			return $.Deferred().resolve();
		},

		error: function(text) {
			window.alert(text);
		}
	};

})(window.jQuery, window.BaseAPI);